<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    长岭陂站<br>
站点介绍<br>
长岭陂站位于留仙大道与长源村以北，车站主体沿留仙大道呈东西走向。车站南侧为在建项目，东南紧邻联检楼，南侧有规划大沙河，西南侧有消防大厦。该站为高架站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:09	23:34	5号线	3分钟	5分25秒<br>
黄贝岭	06:13	23:47	5号线	3分钟	5分25秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:27	23:34	5号线	4分钟	6分钟<br>
黄贝岭	06:03	23:47	5号线	4分钟	6分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:27	00:34	5号线	4分钟	6分钟<br>
黄贝岭	06:03	00:47	5号线	4分钟	6分钟<br><br>

站点出口信息<br><br>
A1出入口:<br>
京基御景峰、留仙大道南侧（西）、长源居委会<br><br>
A2出入口:<br>
留仙大道东侧<br><br>
C出入口:<br>
长岭陂水库、留仙大道北侧<br><br>
D出入口:<br>
留仙大道南侧（东）<br><br>
公交换乘信息<br><br>
A1出入口:<br>
公交站名： 长岭陂地铁站<br>
43、74、81、M217、M299、M343、M385、M393、M459、M460、M554、M566、高峰专线150<br><br>
A2出入口:<br>
公交站名： 长岭陂地铁站<br>
43、74、81、M217、M299、M343、M385、M393、M459、M460、M554、高峰专线150、M566<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "wuhaoxian",
          title: "5号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>


